import { CurriculumType } from '@/util/enum';
import { fmtMsg } from 'commonui';
import { ReportsModule } from '@/modules/reports-objective';
import { Vue, Component } from "vue-property-decorator";
import { ApplicationViews } from "@/util/enum";
import { Tree } from "ant-design-vue";
import { ReportsLocale } from '@/locales/localeid';
import Spinning from "@/components/spinning/spinning.vue";
import LabelText from "@/components/label-text/label-text.vue";

@Component({
	components: {
		Tree,
		Spinning,
		LabelText,
	}
})
export default class UnitOverview extends Vue {
	public view = ApplicationViews.UnitOverview;
	ReportsLocale = ReportsLocale;
	public expandedKeys: string[] = [];
	public autoExpandParent = true;

	localizeString(key) {
		return fmtMsg(key);
	}

	get getClassByUnit() {
		return this.isGrapeSEED ? `theme-${this.unit}` : `theme-ls-${this.unit}`;
	}

	get getSubClassByLicenseType() {
		return this.isGrapeSEED ? `theme-${this.unit}` : `theme-ls-subColor`;
	}

	get unit() {
		return ReportsModule.selectedUnit ?.unit;
	}

	get displayName() {
		const splites = ReportsModule.selectedUnit ?.displayName.split(" ");
		splites ?.pop();
		return splites ?.join(" ");
	}

	get isGrapeSEED() {
		return ReportsModule.selectedUnit ?.curriculumType == CurriculumType.GrapeSEED;
	}

	get vpcsTwoDimension() {
		return ReportsModule.vpcsTwoDimension;
	}

	get reviewVpcs() {
		return ReportsModule.reviewVpcs;
	}

	get hasVpcs() {
		return this.vpcsTwoDimension.length && this.vpcsTwoDimension[0].length;
	}

	get hasReviewVpcs() {
		return this.reviewVpcs.length && this.reviewVpcs[0].length;
	}

	get hasPhonograms() {
		return this.phonogramCards.focuses ?.length || this.phonogramCards.reviews ?.length;
	}

	get hasFocusPhonograms() {
		return this.phonogramCards.focuses ?.length;
	}

	get hasReviewPhonograms() {
		return this.phonogramCards.reviews ?.length;
	}

	get phonogramCards() {
		return ReportsModule.phonogramCards;
	}

	get firstObjectives() {
		return ReportsModule.firstObjectives;
	}

	get loading() {
		return ReportsModule.isLoading;
	}

	formatClass(item) {
		return `title-level-${item.level}`;
	}
}
